import React from 'react';
import { Header } from 'semantic-ui-react';

import { Fecha } from 'src/componentes';
import { HeaderNombreDeCurso } from '../../../componentes';
import { DetallesDelCurso } from '../../tipos';

export const Encabezado = (props: { curso: DetallesDelCurso }) => {
    return (
        <>
            <HeaderNombreDeCurso curso={props.curso} />

            <Header textAlign='center'>
                Clase {props.curso.numeroDeClase}
                <Header.Subheader>
                    <Fecha fecha={props.curso.fechaDeHoy} />
                </Header.Subheader>
            </Header>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/modulos/Horarios/DetalleDelCurso/Asistencia/IngresarAsistencia/Encabezado.tsx